import { useEffect, useState } from 'react';
import styled from 'styled-components';
import FeaturedContent from '../shared/FeaturedContentCard';
import ButtonLink from '../shared/ButtonLinkComponent';
import ServerStylesConditionalWrapper from '../shared/ServerStylesConditionalWrapper';
import { device } from '../../utils/styled-component-mixins';
import bannerBackground from '../assets/images/banner-hero-background.png';

const HeroComponentStyled = styled.div`
  .hero {
    ${(props) =>
      props.absoluteUrl &&
      props.layout === 'banner' &&
      `background: url("${
        props.mobileBackgroundImage ?? `${props.absoluteUrl}/dist/${bannerBackground}`
      }");`}
    ${(props) =>
      !props.absoluteUrl &&
      props.layout === 'banner' &&
      `background: url("${props.mobileBackgroundImage ?? `/dist/${bannerBackground}`}");`}
    background-position: left center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    margin-bottom: 8rem;
    padding-bottom: 1rem;
    padding-top: 4rem;

    @media ${device.desktop} {
      ${(props) =>
        props.absoluteUrl &&
        props.layout === 'banner' &&
        `background: url("${
          props.backgroundImage ?? `${props.absoluteUrl}/dist/${bannerBackground}`
        }");`}
      ${(props) =>
        !props.absoluteUrl &&
        props.layout === 'banner' &&
        `background: url("${props.backgroundImage ?? `/dist/${bannerBackground}`}");`}
      background-position: left center;
      background-repeat: no-repeat;
      background-size: cover;
      padding-bottom: 4rem;
      padding-top: 4rem;
    }

    .breadcrumbs {
      * {
        ${(props) => props.lightDarkTheme === 'dark' && `color: var(--white);`}
      }

      ul li a:not(.non-default-link) {
        ${(props) => props.lightDarkTheme === 'dark' && `color: var(--white);`}

        &:hover {
          ${(props) => props.lightDarkTheme === 'dark' && `text-decoration-color: var(--white);`}
        }
      }
    }

    .container-padding-md {
      position: relative;
    }

    .featured-content-card {
      .featured-content-description {
        > * {
          line-height: 2rem;
          letter-spacing: 0.05rem;
        }
      }
    }

    &.hero-type-banner {
      background-position: right center;

      @media ${device.desktop} {
        background-position: left center;
      }

      .hero-content-wrapper {
        position: relative;
      }

      .hero-copy {
        margin-bottom: 2rem;
        margin-top: 5rem;

        @media ${device.desktop} {
          margin-bottom: 0.6rem;
          max-width: 65rem;
        }

        .btn-wrapper {
          margin-top: 4rem;
        }

        .hero-summary {
          p {
            font-size: 2.2rem;
            line-height: 3.2rem;

            @media ${device.desktop} {
              font-size: 2.6rem;
              line-height: 4rem;
            }
          }
        }
      }

      .featured-content-card {
        margin-top: 4.4rem;
        position: relative;
        right: 0;
        top: 0;
        transform: none;

        @media ${device.desktop} {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          margin-top: 0;
        }
      }
    }

    &.hero-type-homeHero {
      justify-content: center;
      ${(props) =>
        props.mobileBackgroundImage && `background-image: url("${props.mobileBackgroundImage}");`}
      display: flex;
      min-height: 72rem;
      background-repeat: no-repeat;
      background-size: cover;

      @media ${device.desktop} {
        ${(props) => props.backgroundImage && `background-image: url("${props.backgroundImage}");`}
        margin-bottom: 8rem;
      }

      .hero-content-wrapper {
        margin-block: auto;
      }

      .hero-summary,
      .hero-summary p {
        font-size: 1.8rem;

        @media ${device.desktop} {
          font-size: 2.6rem;
          line-height: 4rem;
        }
      }

      .hero-copy {
        margin-inline: auto;
        text-align: left;
        max-width: 100rem;

        ${(props) => props.lightDarkTheme === 'dark' && 'color: var(--white);'}

        h1 {
          font-size: 5rem;
          line-height: 5rem;
          ${(props) => props.lightDarkTheme === 'dark' && 'color: var(--white);'}

          @media ${device.tablet} {
            font-size: 7rem;
            line-height: 7rem;
          }
        }

        .btn-wrapper {
          margin-top: 3rem;

          span {
            ${(props) => props.lightDarkTheme === 'dark' && 'color: var(--white)'}
          }

          @media ${device.desktop} {
            justify-content: center;
          }
        }

        @media ${device.tablet} {
          padding-inline: 4rem;
        }

        @media ${device.desktop} {
          text-align: center;
        }
      }
    }

    &.hero-no-bottom-margin {
      margin-bottom: 0rem !important;
    }

    &.hero-type-bannerImage {
      --featured-content-half-height: 5.6rem;
      ${(props) => props.hasFeaturedContent && `margin-bottom: 16.4rem;`}
      ${(props) =>
        props.mobileBackgroundImage && `background-image: url("${props.mobileBackgroundImage}");`}

      @media ${device.tablet} {
        min-height: 39.4rem;
      }

      @media ${device.tablet} {
        min-height: 39.4rem;
      }

      @media ${device.desktop} {
        margin-bottom: 8rem;
        min-height: 39.4rem;
        ${(props) => props.backgroundImage && `background-image: url("${props.backgroundImage}");`}
      }

      .hero-content-wrapper {
        ${(props) => props.layout === 'homeHero' && 'margin-inline: auto;'}
        @media ${device.deviceOnly} {
          ${(props) =>
            props.hasFeaturedContent ? `margin-bottom: 22.8rem;` : `margin-bottom: 28.0rem;`}
        }
      }

      .hero-copy {
        margin-top: 5rem;

        @media ${device.tablet} {
          margin-top: 1.3rem;

          h1 {
            max-width: 43rem;
          }
        }

        .btn-wrapper {
          margin-top: 4rem;
          ${(props) => (props.containerPageIsFullWidthInsight ? `margin-bottom: 4rem;` : ``)}
        }

        .hero-summary {
          max-width: 80%;

          @media ${device.desktop} {
            max-width: 100%;
          }

          p {
            font-size: 1.8rem;
            line-height: 2.4rem;

            @media ${device.desktop} {
              font-size: 2.6rem;
              line-height: 4rem;
            }
          }
        }
      }

      .featured-content-card {
        margin-top: 0;
        right: 50%;
        top: calc(100% - var(--featured-content-half-height));
        transform: translateX(50%);
        width: calc(100% - 3rem);

        @media ${device.desktop} {
          position: relative;
          right: 0;
          top: 50%;
          transform: none;
        }
      }
    }

    &.hero-type-hero {
      --featured-content-half-height: 5.6rem;
      ${(props) => props.hasFeaturedContent && `margin-bottom: 16.4rem;`}
      ${(props) =>
        props.mobileBackgroundImage &&
        props.layout !== 'banner' &&
        `background-image: url("${props.mobileBackgroundImage}");`}
      position: relative;
      background-position: left center;
      background-repeat: no-repeat;
      background-size: cover;

      @media ${device.desktop} {
        margin-bottom: 0;
        min-height: 83rem;
        ${(props) =>
          props.backgroundImage &&
          props.layout !== 'banner' &&
          `background-image: url("${props.backgroundImage}");`}
        background-position: right top;
        margin-bottom: -15%;
        overflow: hidden;
      }

      &:before {
        @media ${device.desktop} {
          background-color: var(--white);
          background: rgb(255, 255, 255);
          background: linear-gradient(
            35deg,
            rgba(255, 255, 255, 1) 56%,
            rgba(0, 212, 255, 0) 56.1%
          );
          background-repeat: no-repeat;
          content: '';
          height: 100%;
          min-width: 156rem;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }

        @media ${device.desktoplG} {
          min-width: 180rem;
        }

        @media (min-width: 1790px) {
          background: linear-gradient(
            35deg,
            rgba(255, 255, 255, 1) 62%,
            rgba(0, 212, 255, 0) 62.1%
          );
        }
      }

      .hero-content-wrapper {
        ${(props) =>
          props.hasFeaturedContent ? `margin-bottom: 22.8rem;` : `margin-bottom: 28.0rem;`}

        @media ${device.desktop} {
          margin-top: 8.8rem;
        }
      }

      .hero-copy {
        margin-top: 5rem;

        @media ${device.desktop} {
          margin-bottom: 0;
          margin-top: 0;
        }

        .btn-wrapper {
          margin-top: 4rem;
        }

        .hero-summary {
          max-width: 80%;

          @media ${device.desktop} {
            max-width: 100%;
          }

          p {
            font-size: 1.8rem;
            line-height: 2.4rem;

            @media ${device.desktop} {
              font-size: 2.6rem;
              line-height: 4rem;
            }
          }
        }
      }

      .featured-content-card {
        margin-top: 0;
        right: 50%;
        top: calc(100% - var(--featured-content-half-height));
        transform: translateX(50%);
        width: calc(100% - 3rem);

        @media ${device.desktop} {
          position: relative;
          right: 0;
          top: 50%;
          transform: none;
        }
      }
    }

    h1 {
      ${(props) => props.lightDarkTheme === 'dark' && 'color: var(--white);'}
      margin-bottom: 1.6rem;
      margin-top: 3.2rem;

      @media ${device.desktop} {
        margin-top: 3.4rem;
      }
    }

    .hero-content-wrapper {
      display: flex;
      flex-direction: column;

      @media ${device.desktop} {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        z-index: 100;
      }
    }

    .hero-copy {
      max-width: 38rem;
      @media ${device.mobileLg} {
        max-width: 56rem;
      }

      h1 {
        margin-top: 0;
      }

      * {
        ${(props) => props.lightDarkTheme === 'dark' && 'color: var(--white);'}
      }

      .hero-summary {
        p:first-child {
          margin-top: 0;
        }
        p:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  video {
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    clip-path: inset(1px 1px);
  }

  .video-wrapper {
    height: 45rem;
    position: relative;
    overflow: hidden;
    text-align: center;
    display: none;
    align-items: center;
    justify-content: center;
  }

  @media ${device.tablet} {
    .hero-video {
      position: absolute !important;
      top: 13rem;
    }

    .video-wrapper {
      display: flex !important;
    }
  }

  @media ${device.mobileLg} {
    .hero-video {
      background-image: none !important;
    }
  }

  @media ${device.mobileOnly} {
    .hero-video {
      height: 35rem !important;

      .hero-copy {
        margin-top: 0 !important;
      }
    }
  }

  .hero-video-pause-button {
    background-image: url('/getmedia/69110f76-8c7a-4c64-805f-a7c748ff54dc/video-pause-button-white.svg');
  }

  .hero-video-play-button {
    background-image: url('/getmedia/df824d71-8d4d-4708-8f9f-2022268f7264/video-play-button-white.svg');
  }

  .hero-video-control {
    height: 40px;
    width: 40px;
    position: absolute;
    bottom: 5%;
    right: 1.5%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: invert(100%) brightness(119%) contrast(119%);
    transition: 0.3s ease-in-out, color 0.1s ease-in-out;
  }

  .hero-video-control.hero-video-pause-button.light {
    filter: none !important;
  }

  .hero-video-control.hero-video-play-button.light {
    filter: none !important;
  }
`;

const HeroComponent = (props) => {
  const {
    layout,
    title,
    description,
    backgroundVideo,
    backgroundImage,
    breadcrumbContent,
    ctaButtonText,
    ctaButtonType,
    ctaButtonUrl,
    icon,
    ctaLinkIsExternal,
    containerPageIsFullWidthInsight,
    lightDarkTheme,
    hasFeaturedContent,
    featuredContentDescription,
    featuredContentHeading,
    featuredContentLinkText,
    featuredContentLinkUrl,
    mobileBackgroundImage,
    ctaButtonLinkTarget,
    removeBottomMargin
  } = props;

  const [urlOrigin, setUrlOrigin] = useState('');

  const noBottomMargin = removeBottomMargin ? 'hero-no-bottom-margin' : '';

  const [isPaused, setActive] = useState(false);
  const togglePlay = () => {
    setActive(!isPaused);
    if (!isPaused) {
      document.getElementById('hero-video').pause();
    } else {
      document.getElementById('hero-video').play();
    }
  };

  useEffect(() => {
    setUrlOrigin(origin);
  }, []);

  return (
    <ServerStylesConditionalWrapper>
      <HeroComponentStyled
        layout={layout}
        backgroundImage={backgroundImage}
        mobileBackgroundImage={mobileBackgroundImage}
        lightDarkTheme={lightDarkTheme}
        hasFeaturedContent={hasFeaturedContent}
        absoluteUrl={urlOrigin.current}
        containerPageIsFullWidthInsight={containerPageIsFullWidthInsight}
      >
        {backgroundVideo ? (
          <div className="video-wrapper">
            <video autoPlay muted loop id="hero-video">
              <source src={backgroundVideo} type="video/mp4"></source>
              Your browser does not support the video tag.
            </video>
            <div
              className={`hero-video-control ${
                isPaused ? 'hero-video-play-button' : 'hero-video-pause-button'
              } ${lightDarkTheme}`}
              onClick={togglePlay}
            ></div>
            <div className="hidden">
              <img
                id="hero-video-play-pre-cache"
                src="/getmedia/df824d71-8d4d-4708-8f9f-2022268f7264/video-play-button-white.svg"
              ></img>
            </div>
          </div>
        ) : (
          ''
        )}
        <div
          className={`hero hero-type-${layout} ${noBottomMargin} ${
            backgroundVideo ? 'hero-video' : ''
          }`}
        >
          <div className="container-padding-md">
            <div dangerouslySetInnerHTML={{ __html: breadcrumbContent }}></div>
            <div className="hero-content-wrapper">
              <div className="hero-copy">
                <h1>{title}</h1>
                <div className="hero-summary">
                  <p>{description}</p>
                </div>
                {ctaButtonText && (
                  <ButtonLink
                    type={ctaButtonType}
                    text={ctaButtonText}
                    link={ctaButtonUrl}
                    target={ctaButtonLinkTarget}
                    isExternal={ctaLinkIsExternal}
                    icon={icon}
                  />
                )}
              </div>
              {hasFeaturedContent && layout !== 'homeHero' && (
                <FeaturedContent
                  description={featuredContentDescription}
                  heading={featuredContentHeading}
                  linkText={featuredContentLinkText}
                  linkUrl={featuredContentLinkUrl}
                />
              )}
            </div>
          </div>
        </div>
      </HeroComponentStyled>
    </ServerStylesConditionalWrapper>
  );
};

export default HeroComponent;
